export const metersToFeets = (meters: number): number => {
  return meters / 0.3048;
};

